import { required, useRecordContext } from "ra-core";
import { useWatch } from "react-hook-form";
import { DateInput } from "@/components/admin/date-input";
import { NumberInput } from "@/components/admin/number-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import {
  paymentDirectionChoices,
  paymentStatusChoices,
} from "./paymentModel";

export const PaymentInputs = () => {
  const direction = useWatch({ name: "direction" });
  const record = useRecordContext();
  const isEdit = !!record;
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <SelectInput
        source="direction"
        choices={paymentDirectionChoices}
        validate={required()}
        helperText={false}
      />
      <NumberInput source="amount" validate={required()} helperText={false} />
      <DateInput source="planned_date" validate={required()} helperText={false} />
      {isEdit && <DateInput source="paid_date" helperText={false} />}
      {isEdit && (
        <SelectInput
          source="status"
          choices={paymentStatusChoices}
          validate={required()}
          helperText={false}
        />
      )}
      <ReferenceInput
        source="category_id"
        reference="transaction_categories"
        filter={direction ? { direction } : undefined}
      >
        <AutocompleteInput
          label="resources.payments.fields.category_id"
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput source="contract_id" reference="contracts">
        <AutocompleteInput
          label="resources.payments.fields.contract_id"
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput
        source="account_id"
        reference="accounts"
        filter={{ "archived_at@is": null }}
      >
        <AutocompleteInput
          label="resources.payments.fields.account_id"
          optionText="name"
          helperText={false}
        />
      </ReferenceInput>
      <TextInput
        source="vendor_name"
        label="resources.payments.fields.vendor_name"
        helperText={false}
      />
      <TextInput
        source="comment"
        multiline
        rows={3}
        className="md:col-span-2"
        helperText={false}
      />
    </div>
  );
};
